import React from 'react';
import './SupportSection.css';
import abcLogo from '../assets/abc_software_logo.jpeg';
import modLogo from '../assets/mod_logo.png';
import lvrLogo from '../assets/lvr_logo.jpeg';
import lmtLogo from '../assets/lmt_logo.png';

const SupportSection = () => {
  const partners = [
    { logo: abcLogo, name: "ABC Software", alt: "ABC Software", url: "https://www.abcsoftware.lv/" },
    { logo: modLogo, name: "Ministry of Defence", alt: "Ministry of Defence", url: "https://www.mod.gov.lv/" },
    { logo: lvrLogo, name: "LVR", alt: "LVR", url: "https://www.lvrtc.lv/" },
    { logo: lmtLogo, name: "LMT", alt: "LMT", url: "https://www.lmt.lv/" },
  ];

  return (
    <section className="partners">
      <div className="container">
        <div className="partners-content">
          <div className="partners-label">
            <span className="section-label">Our Partners</span>
            <h3>Backed by Industry Leaders</h3>
          </div>

          <div className="partners-logos">
            {partners.map((partner, index) => (
              <a
                href={partner.url}
                className="partner-logo"
                key={index}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={partner.logo} alt={partner.alt} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportSection;
